module.exports = __webpack_public_path__ + "img/spoc_bg.4fe129f2.png";